import React, { useEffect } from 'react';
import Swiper from 'swiper';

const TestimonialsComponent = () => {

  useEffect(() => {
    
    const swiper = new Swiper('.swiper', {
      speed: 600,
      delay: 5000,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });

    
    return () => {
      swiper.destroy();
    };
  }, []);

  return (
    <section id="testimonials" className="testimonials section">

      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>What Our Clients Say</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="swiper init-swiper" data-speed="600" data-delay="5000" data-breakpoints="{ &quot;320&quot;: { &quot;slidesPerView&quot;: 1, &quot;spaceBetween&quot;: 40 }, &quot;1200&quot;: { &quot;slidesPerView&quot;: 3, &quot;spaceBetween&quot;: 40 } }">
          <div className="swiper-wrapper">

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className=" bi bi-quote quote-icon-left"></i>
                  <span>TRB exceeded our expectations with their exceptional service and expertise. Their tailored solutions significantly improved our project outcomes and efficiency!</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                <h3>Robert H.</h3>
                <h4>Project Manager</h4>
                </p>
                {/* <img src="assets/img/testimonials/testimonials-1.jpg" className="testimonial-img" alt="" /> */}
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>Our experience with TRB was outstanding! They delivered innovative software that streamlined our operations, and their support team was always responsive and helpful.</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                <h3>Linda G.</h3>
                <h4>Operations Director</h4>
                </p>
                {/* <img src="assets/img/testimonials/testimonials-2.jpg" className="testimonial-img" alt="" /> */}
              </div>
            </div>

            <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>Working with TRB has been a game changer for us. Their responsive support and innovative strategies helped us achieve our business goals faster than expected.</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                <h3>Amanda T.</h3>
                <h4>Business Development Manager</h4>
                </p>
                {/* <img src="assets/img/testimonials/testimonials-3.jpg" className="testimonial-img" alt="" /> */}
              </div>
            </div>

            {<div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>They demonstrated professionalism, delivering the project on time and within budget. We are extremely satisfied with their work and highly recommend their services!</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                <h3>Shubham Aggarwal</h3>
                <h4>Founder</h4>
                </p>
                {/* <img src="assets/img/testimonials/testimonials-4.jpg" className="testimonial-img" alt="" /> */}
              </div>
            </div>

            /* <div className="swiper-slide">
              <div className="testimonial-item">
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                </p>
                <img src="assets/img/testimonials/testimonials-5.jpg" className="testimonial-img" alt="" />
                <h3>John Larson</h3>
                <h4>Entrepreneur</h4>
              </div>
            </div> */}

          </div>
          <div className="swiper-pagination"></div>
        </div>

      </div>

    </section>
    // Teams Section
    // <section id="team" className="team section light-background">
    //   <div className="container section-title" data-aos="fade-up">
    //     <h2>Team</h2>
    //     <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
    //   </div>

    //   <div className="container">

    //     <div className="row gy-4">

    //       <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
    //         <div className="team-member">
    //           <div className="member-img">
    //             <img src="assets/img/team/team-1.jpg" className="img-fluid" alt="" />
    //             <div className="social">
    //               <a href=""><i className="bi bi-twitter-x"></i></a>
    //               <a href=""><i className="bi bi-facebook"></i></a>
    //               <a href=""><i className="bi bi-instagram"></i></a>
    //               <a href=""><i className="bi bi-linkedin"></i></a>
    //             </div>
    //           </div>
    //           <div className="member-info">
    //             <h4>Walter White</h4>
    //             <span>Chief Executive Officer</span>
    //           </div>
    //         </div>
    //       </div>

    //       <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
    //         <div className="team-member">
    //           <div className="member-img">
    //             <img src="assets/img/team/team-2.jpg" className="img-fluid" alt="" />
    //             <div className="social">
    //               <a href=""><i className="bi bi-twitter-x"></i></a>
    //               <a href=""><i className="bi bi-facebook"></i></a>
    //               <a href=""><i className="bi bi-instagram"></i></a>
    //               <a href=""><i className="bi bi-linkedin"></i></a>
    //             </div>
    //           </div>
    //           <div className="member-info">
    //             <h4>Sarah Jhonson</h4>
    //             <span>Product Manager</span>
    //           </div>
    //         </div>
    //       </div>

    //       <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="300">
    //         <div className="team-member">
    //           <div className="member-img">
    //             <img src="assets/img/team/team-3.jpg" className="img-fluid" alt="" />
    //             <div className="social">
    //               <a href=""><i className="bi bi-twitter-x"></i></a>
    //               <a href=""><i className="bi bi-facebook"></i></a>
    //               <a href=""><i className="bi bi-instagram"></i></a>
    //               <a href=""><i className="bi bi-linkedin"></i></a>
    //             </div>
    //           </div>
    //           <div className="member-info">
    //             <h4>William Anderson</h4>
    //             <span>CTO</span>
    //           </div>
    //         </div>
    //       </div>

    //       <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="400">
    //         <div className="team-member">
    //           <div className="member-img">
    //             <img src="assets/img/team/team-4.jpg" className="img-fluid" alt="" />
    //             <div className="social">
    //               <a href=""><i className="bi bi-twitter-x"></i></a>
    //               <a href=""><i className="bi bi-facebook"></i></a>
    //               <a href=""><i className="bi bi-instagram"></i></a>
    //               <a href=""><i className="bi bi-linkedin"></i></a>
    //             </div>
    //           </div>
    //           <div className="member-info">
    //             <h4>Amanda Jepson</h4>
    //             <span>Accountant</span>
    //           </div>
    //         </div>
    //       </div>

    //     </div>

    //   </div>

    // </section>
  )
}

export default TestimonialsComponent;